import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {MatDialog, MatDialogConfig} from '@angular/material/dialog';
import {DimmedOptionChosenDialogComponent} from '../dimmed-option-chosen-dialog/dimmed-option-chosen-dialog.component';
import {TileGroupComponent} from '../tile-group/tile-group.component';
import {ProductsService} from '../../shared/services/products.service';
import {BreakpointObserver} from "@angular/cdk/layout";
import {BREAKPOINTS} from "../../shared/constants/breakpoints";

@Component({
  selector: 'mbnm-filters',
  templateUrl: './filters.component.html',
  styleUrls: ['./filters.component.scss']
})
export class FiltersComponent implements OnInit {

  constructor(public media: BreakpointObserver, public dialog: MatDialog, private productService: ProductsService) { }

  ngOnInit() {
  }

  @ViewChild('tiles')
  tiles: TileGroupComponent;

  @Input()
  options: any;

  @Input()
  productData: Array<any>;

  @Input()
  skipNoMatchesWarning: boolean;

  @Input()
  productName: string;

  @Output()
  filterChanged: EventEmitter<Array<any>> = new EventEmitter<Array<any>>();

  deselect(): void {
    this.tiles.selectedTile = null;
  }

  onSelectionChanged(newValue, currentOption) {
    currentOption.previousSelection = currentOption.selection;
    currentOption.selection = newValue;
    this.updateFilteredProduct(currentOption);
  }

  updateFilteredProduct(currentOption) {
    // calculate the tags
    let tags = this.productService.getTags(this.options);

    // apply the current filters
    let filteredData = this.productService.filterByTags(this.productData, tags);


    let onSelectionChangedContinue = () => {
      // test all possible matches & dim any options that will result in no matches
      this.options.forEach(option => {
        option.choices.forEach(choice => {
          const oldTagValue = tags[option.tagName];
          tags[option.tagName] = choice.value;
          choice.dim = this.productService.filterByTags(this.productData, tags).length == 0;
          if (typeof oldTagValue === 'undefined') {
            delete tags[option.tagName];
          } else {
            tags[option.tagName] = oldTagValue;
          }
        });
      });

      // go over options again and re-select the previous value if its not dimmed
      // or the first available if it is
      let changeOccured: boolean = false;
      this.options.forEach(option => {
        option.choices.forEach(choice => {
          if (option.selection == null) {
            const previousSelection = option.choices.filter(choice => choice.value == option.previousSelection)[0];
            if (previousSelection && !previousSelection.dim) {
              option.selection = previousSelection.value;
            } else {
              const firstAvailableSelection = option.choices.filter(choice => !choice.dim)[0];
              option.selection = firstAvailableSelection.value;
            }
            tags[option.tagName] = option.selection;
            changeOccured = true;
          }
        });
      });

      // if any change occurred, update the available mats to reflect the new tags
      if (changeOccured) {
        filteredData = this.productService.filterByTags(this.productData, tags);
      }

      // output the changed data
      this.filterChanged.emit(filteredData);
    };

    // if we will end up with zero results, change tags and get some good results
    if (filteredData.length === 0) {
      if (this.skipNoMatchesWarning === false) {
        const config = new MatDialogConfig();

        if (this.media.isMatched(BREAKPOINTS.Standard.XSmall)) {
          config.backdropClass = 'light-backdrop';
          config.width = '100vw';
          config.maxWidth = '90vw';
        } else {
          config.width = '350px';
        }

        const dialogRef = this.dialog.open(DimmedOptionChosenDialogComponent, config);
        dialogRef.disableClose = true;
        dialogRef.componentInstance.data = {
          selection: {
            value: currentOption.selection,
            format: currentOption.descriptiveStringFormat
          },
          previousSelection: {
            value: currentOption.previousSelection,
            format: currentOption.descriptiveStringFormat
          },
          otherSelections: this.options.filter(option => option !== currentOption).map(option => {
            return {
              value: option.selection,
              format: option.descriptiveStringFormat
            }
          }),
          productName: this.productName
        };

        dialogRef.afterClosed().subscribe(result => {
          if (result === 'keep') {
            this.options.forEach(option => {
              if (option !== currentOption) {
                option.previousSelection = option.selection;
                option.selection = null;
                delete tags[option.tagName];
              }
            });

            filteredData = this.productService.filterByTags(this.productData, tags);
            onSelectionChangedContinue();
          } else {
            tags[currentOption.tagName] = currentOption.previousSelection;
            currentOption.selection = currentOption.previousSelection;
            currentOption.previousSelection = null;
          }
        });
      } else {
        this.options.forEach(option => {
          if (option !== currentOption) {
            option.previousSelection = option.selection;
            option.selection = null;
            delete tags[option.tagName];
          }
        });

        filteredData = this.productService.filterByTags(this.productData, tags);
        onSelectionChangedContinue();
      }
    } else {
      onSelectionChangedContinue();
    }
  }
}
